import { render, staticRenderFns } from "./StopsTemplate.vue?vue&type=template&id=4d857dfa&scoped=true&"
import script from "./StopsTemplate.vue?vue&type=script&lang=js&"
export * from "./StopsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StopsTemplate.vue?vue&type=style&index=0&id=4d857dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d857dfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VBtn,VIcon})
